import { type ComponentProps } from 'react'
import { twMerge } from 'tailwind-merge'

interface SidepanelSectionBodyProps extends ComponentProps<'div'> {}

export function SidepanelSectionBody({ className, children, ...props }: SidepanelSectionBodyProps) {
  return (
    <div className={twMerge('flex flex-col gap-1.5', className)} {...props}>
      {children}
    </div>
  )
}
